import type { TranslationMessages } from '../types';

export const orders_report: TranslationMessages = {
      name: 'Báo cáo đơn hàng',
      subtitle: 'Phân tích hiệu suất đơn hàng và xu hướng doanh thu',
      export_report: 'Xuất báo cáo',
      select_date_range: 'Chọn khoảng thời gian',
      choose_period: 'Chọn khoảng thời gian bạn muốn phân tích',
      from_date: 'Từ ngày',
      to_date: 'Đến ngày',
      generate_report: 'Tạo báo cáo',
      generating_report: 'Đang tạo báo cáo...',
      loading_report: 'Đang tải báo cáo...',
      fetching_data: 'Đang lấy dữ liệu cho khoảng thời gian đã chọn.',
      failed_to_load: 'Không thể tải báo cáo',
      try_again_message:
        'Vui lòng thử lại hoặc liên hệ hỗ trợ nếu vấn đề vẫn tiếp tục.',
      try_again: 'Thử lại',
      total_revenue: 'Tổng doanh thu',
      days_period: 'ngày',
      total_orders: 'Tổng số đơn hàng',
      total_orders_in_period: 'Tổng số đơn hàng trong kỳ',
      average_daily: 'Trung bình hàng ngày',
      per_day_average: 'Trung bình mỗi ngày',
      daily_breakdown: 'Phân tích hàng ngày',
      revenue_breakdown_description:
        'Phân tích doanh thu theo ngày cho khoảng thời gian đã chọn',
      no_orders_found: 'Không tìm thấy đơn hàng',
      no_orders_message:
        'Không tìm thấy đơn hàng nào cho khoảng thời gian đã chọn. Hãy thử điều chỉnh khoảng thời gian của bạn.',
      order: 'đơn hàng',
      revenue_chart: 'Biểu đồ doanh thu',
      revenue_chart_description:
        'Doanh thu và số đơn hàng theo ngày trong khoảng thời gian đã chọn',
      revenue: 'Doanh thu',
      orders: 'Đơn hàng',
      quick_select: 'Chọn nhanh',
      preset_yesterday: 'Hôm qua',
      preset_today: 'Hôm nay',
      preset_this_week: 'Tuần này',
      preset_this_month: 'Tháng này',
      preset_current_fiscal_month: 'Tháng Tài chính Hiện tại',
      preset_previous_fiscal_month: 'Tháng Tài chính Trước',
      preset_last_week: 'Tuần trước',
      preset_last_month: 'Tháng trước',
      preset_this_year: 'Năm nay',
      preset_last_year: 'Năm trước',
      preset_custom: 'Tùy chỉnh',
      delivered_orders: 'Đã giao',
      cancelled_orders: 'Đã hủy',
      platform_filter: 'Bao Gồm Nền Tảng',
    };
